import  "./forgotPassword.scss";
import apiRequest from "../../../lib/apiRequest";
import React, { useState } from "react";
import { useApiError } from "../../../lib/errorHandler";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

const handleApiError=useApiError();

  // Handle email input change
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };


const validateForm = ({ email }) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email || !emailRegex.test(email)) {
    return "Please enter a valid email address.";
  }
  return null; // no errors
};






  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage("");

    const formData = new FormData(event.target);
    const email = formData.get("email");




    const validationError = validateForm({ email });
    if (validationError) {
      setError(validationError);
      handleApiError({ message: validationError }); // show toast    

      return; // stop execution
    }





    try {
      // Use apiRequest to send the POST request
      const response = await apiRequest.post("/users/forgot", { email });
  
      // Axios automatically parses JSON, no need for response.json()
      if (response && response.data) {
        setMessage(response.data.message);
      } else {
        throw new Error("Failed to send password reset email");
      }
    } catch (error) {
      // Axios errors are slightly different
      if (error.response && error.response.data && error.response.data.message) {
        setMessage(error.response.data.message); // if backend sends error message
      } else {
        setMessage(error.message); // fallback
      }
    } finally {
      setLoading(false);
    }  };

  return (
    <div className="forgot-password">
      <h2>Forgot Password</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Enter your email address:</label>
          <input
            name='email'
            type="email"
            id="email"
            value={email}
            onChange={handleEmailChange}
            required
            placeholder="Enter your email"
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send Password Reset Link"}
        </button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ForgotPassword;
